import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';
const Container = styled.div`
  width: 100%;
  max-width: 449px;
  height: 100vh;
`;
const Group = styled.div`
  height: calc(100vh - 53px);
  background-color: var(--background-secondary);
  ${FlexBetween}
  flex-direction: column;
  padding-top: var(--space-48);
`;
const Content = styled.div`
  padding-inline: var(--space-20);
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-32);
`;
const TopContent = styled.div`
  ${FlexBetween}
  flex-direction: column;
`;

const Icon = styled.div`
  padding-bottom: var(--space-16);
`;
const Title = styled.div`
  padding-bottom: var(--space-12);
  color: var(--text-primary);
  ${Typography.heading_lg}
  text-align: center;
`;
const Description = styled.div`
  color: var(--text-secondary);
  ${Typography.body_lg}
  text-align: center;
`;
const ButtonDiv = styled.div`
  width: 100%;
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-12);
  .full-width {
    width: 100%;
  }
`;
const Link = styled.a`
  width: 100%;
  padding-block: var(--space-12);
  color: var(--text-secondary);
  ${Typography.body_lg_medium}
  text-decoration: none;
  text-align: center;
`;
const Bottom = styled.div`
  width: 100%;
  .first-img {
    display: flex;
    width: 100%;
    height: auto;
  }
`;
export { Container, TopContent, Group, Content, Icon, Title, Description, ButtonDiv, Link, Bottom };
